var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgParcelTransportIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 37,
    viewBox: "0 0 47 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_986)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.1904 22.77H39.6604V24.16H38.1904V22.77Z",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.0299 13.1801H42.6399V10.2001H41.1299V8.81006H44.0299V13.1801Z",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8896 19.0601H32.2796V20.5301H30.8896V19.0601Z",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.30016 10.2399H5.91016V2.93994H9.54016V4.32994H7.30016V10.2499V10.2399Z",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1299 22.77H42.5999V24.16H41.1299V22.77Z",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7498 28.64C10.5598 28.64 9.58984 29.61 9.58984 30.8C9.58984 31.99 10.5598 32.96 11.7498 32.96C12.9398 32.96 13.9098 31.99 13.9098 30.8C13.9098 29.61 12.9398 28.64 11.7498 28.64ZM11.7498 31.58C11.3198 31.58 10.9798 31.23 10.9798 30.81C10.9798 30.39 11.3298 30.04 11.7498 30.04C12.1698 30.04 12.5198 30.39 12.5198 30.81C12.5198 31.23 12.1698 31.58 11.7498 31.58Z",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5204 28.64C33.3304 28.64 32.3604 29.61 32.3604 30.8C32.3604 31.99 33.3304 32.96 34.5204 32.96C35.7104 32.96 36.6804 31.99 36.6804 30.8C36.6804 29.61 35.7104 28.64 34.5204 28.64ZM34.5204 31.58C34.0904 31.58 33.7504 31.23 33.7504 30.81C33.7504 30.39 34.1004 30.04 34.5204 30.04C34.9404 30.04 35.2904 30.39 35.2904 30.81C35.2904 31.23 34.9404 31.58 34.5204 31.58Z",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.37047 1.39H24.2405V0H2.98047V8.04H4.37047V1.39Z",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8896 16.12H32.2796V17.59H30.8896V16.12Z",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9502 19.0601H29.3402V20.5301H27.9502V19.0601Z",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.29 35.25C39.55 34.18 40.35 32.58 40.35 30.8C40.35 30.28 40.28 29.78 40.15 29.29H46.96V11.71H45.57V19.09H42.15L38.15 15.09V7.26H45.57V9.5H46.96V5.87H35.21V3.34L31.87 0H26.44V1.39H31.29L33.82 3.92V22.03H4.37V10.24H2.98V17.62H0.04V29.29H6.11C5.98 29.78 5.91 30.28 5.91 30.8C5.91 32.58 6.71 34.18 7.97 35.25H0V36.64H47V35.25H38.29ZM34.52 35.25C32.07 35.25 30.07 33.26 30.07 30.8C30.07 30.13 30.21 29.49 30.5 28.89C31.24 27.32 32.78 26.35 34.51 26.35C36.24 26.35 37.78 27.32 38.52 28.89C38.81 29.49 38.95 30.13 38.95 30.8C38.95 33.25 36.96 35.25 34.5 35.25H34.52ZM41.58 20.48H45.58V27.9H39.59C38.67 26.28 37.06 25.22 35.22 25V7.26H36.77V15.67L41.58 20.48ZM1.43 19.02H2.98V22.04H1.43V19.02ZM7.31 30.81C7.31 30.14 7.45 29.5 7.74 28.9C8.48 27.33 10.02 26.36 11.75 26.36C13.48 26.36 15.02 27.33 15.76 28.9C16.05 29.5 16.19 30.14 16.19 30.81C16.19 33.26 14.2 35.26 11.74 35.26C9.28 35.26 7.29 33.27 7.29 30.81H7.31ZM15.53 35.26C16.79 34.19 17.59 32.59 17.59 30.81C17.59 30.29 17.52 29.79 17.39 29.3H19.1V27.91H16.82C15.79 26.09 13.88 24.97 11.76 24.97C9.64 24.97 7.73 26.09 6.7 27.91H1.43V23.42H33.82V25.01C31.98 25.22 30.37 26.29 29.45 27.91H21.29V29.3H28.87C28.74 29.79 28.67 30.29 28.67 30.81C28.67 32.59 29.47 34.19 30.73 35.26H15.51H15.53Z",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.91992 11.71H7.30992V13.18H5.91992V11.71Z",
    fill: "#010101"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_986"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 36.64,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParcelTransportIcon);
export default __webpack_public_path__ + "static/media/parcel-transport-icon.dba90e3d21888b2b2128edcdcaa280ad.svg";
export { ForwardRef as ReactComponent };